import { render } from "./checks.vue?vue&type=template&id=3023b7da&scoped=true"
import script from "./checks.vue?vue&type=script&lang=js"
export * from "./checks.vue?vue&type=script&lang=js"

import "./checks.vue?vue&type=style&index=0&id=3023b7da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3023b7da"]])

export default __exports__